import { ActorActionEnum } from "../constants/actor-action.enum";

export class Workflow {
    workflowName!: string;
    newRequestTitle!: string;
    retentionDays: number = 30;
    requireKVK: boolean = false;
    step1: WorkflowStep1 = new WorkflowStep1;
    step2: WorkflowStep2 = new WorkflowStep2;
    step3: WorkflowStep3 = new WorkflowStep3;
    step4: WorkflowStep4 = new WorkflowStep3;
    /**
     * Holds the key for human readable workflow name for the breadcrumb
     */
    translationKey!: string;
}

export class Placeholder {
    placeholderId!: number;
    allowDelete: boolean = true;
    optional: boolean = false;
    allowMultiple: boolean = false;
}

export class WorkflowStep<T> {
    skipStep: boolean = false;
    allowSorting: boolean = false;
    placeholders: T[] = [];
}

export class WorkflowStep1 extends WorkflowStep<WorkflowStep1Placeholder> {
    supportedDocumentTypes: string[] = ["RegularPdf"];
    maxDocumentAmount!: number;
    minDocumentAmount: number = 1;
    maxFileSizeMB: number = 1024;
    allowRendering: boolean = true;
    onlySpecifiedDocumentExtensions: boolean = false;
    allowAddDocuments: boolean = false;
    allowPreviousSignatures: boolean = false;
}

export class WorkflowStep1Placeholder extends Placeholder {
    text!: string;
    supportedDocumentTypes!: [string];
}

export class WorkflowStep2 extends WorkflowStep<WorkflowStep2Placeholder> {
    maxPersonAmount!: number;
    minPersonAmount: number = 1;
    addCurrentUser: boolean = false;
    allowCurrentUser: boolean = true;
    allowAddPersons: boolean = false;
    /**
     * An Array limiting selection of Identity providers
     * Only allows the set Identity providers, REQUIRED
     * See: Constants->IdentityProviderConstants/identity-provider.constants
     */
    allowedIdentityProviders: string[] = [];
}

export class WorkflowStep2Placeholder extends Placeholder {
    text!: string;
    currentUser: boolean = false;
    anyOfPlaceholdersRequired: number[] = [];
    allOfPlaceholdersRequired: number[] = [];
}

export class WorkflowStep3 extends WorkflowStep<WorkflowStep3Placeholder> {
    maxActionAmount!: number;
    minActionAmount: number = 1;
    defaultDeadlineDaysFromNow?: number;
    allowedActions: AllowedAction[] = [];
    allowAddActions: boolean = false;
    signIsFirstAction: boolean = false;
    defaultSignatureType!: string;
    defaultSignatureProvider!: string;
    allowEditSignatureType: boolean = true;
}

export class WorkflowStep3Placeholder extends Placeholder {
    defaultDocumentPlaceholderId!: number;
    defaultPersonPlaceholderId!: number;
    alternativePersonPlaceholderId?: number | null;
    defaultActions: string[] = [ActorActionEnum.Sign];
    allowedActions: string[] = [
        ActorActionEnum.Sign,
        ActorActionEnum.Approve,
        ActorActionEnum.Download
    ];
    deadlineDateDaysFromNow: number = 7;
    deadlineDaysAfterPreviousAction: number = 7;
    allowedQtsps: string[] | null = null;
}

export class AllowedAction {
    /**
     * Actor Action types : ActorActionEnum is expected
     */
    type!: string;
    maxAmount?: number;
}

export class WorkflowStep4 extends WorkflowStep<WorkflowStep4Placeholder> {

}

export class WorkflowStep4Placeholder extends Placeholder {

}
